import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import * as action from '../../state/search/action'
import * as selector from '../../state/search/selector'
import SalesOrderSearch from './SalesOrderSearch'


const mapStateToProps = state => {
    return {
        tableData: selector.selectRefinementProductionTable(state),
        type: 'refinement-production',
    }
}

const mapDispatchToProps = {
    initialTableQuery: action.initialTableQueryRefinementProduction,
    changeFilter: action.changeFilterRefinementProduction,
    toggleSort: action.toggleSortRefinementProduction,
    toggleMultiSort: action.toggleMultiSortRefinementProduction,
    gotoPage: action.gotoPageRefinementProduction,
    initialColumnsVisibility: action.initialTableSettingsRefinementProduction,
    toggleColumnVisibility: action.toggleColumnVisibilityRefinementProduction,
    navigateToSalesOrder: (salesOrderId) => {
        return push('/sales-order/edit/' + salesOrderId)
    },
}


export default connect(mapStateToProps, mapDispatchToProps)(SalesOrderSearch)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/search/RefinementProductionSalesOrderSearchContainer.js